import useUser from "../../../hooks/useUser";

// The backend's IsSuperAdmin(): SuperAdmin (1) or CustomerSupport (5). useSuperAdmin is role 1 only.
const useSuperAdminOrSupport = () => {
  const { user } = useUser();
  return !!user?.roles.some((el) => el.id === 1 || el.id === 5);
};

export default useSuperAdminOrSupport;
